import Heading from '@/common/shared/heading'
import { Separator } from '@/common/ui/separator'
import { GetDynamicPageByIdDataResponse } from '@/modules/client-setting/type'
import DynamicPageByIdTable from '../DynamicPageByIdTable'
import useQueryProfile from '@/modules/auth/api/hooks/useQueryProfile'
import { PermissionKeys } from '@/modules/manage-member/mappers'
import { useParams } from 'react-router-dom'
import AddSectionToPageModal from '../AddSectionToPageModal'
import NavigateBackButton from '@/common/components/NavigateBackButton'

interface DynamicPageByIdListingProps {
	data: GetDynamicPageByIdDataResponse[]
	total: number
	isLoading?: boolean
	name: string
}

export default function DynamicPageByIdListing({
	data,
	total,
	isLoading,
	name,
}: DynamicPageByIdListingProps) {
	const { data: user } = useQueryProfile()
	const { id: pageId } = useParams()

	const hasWritePermission = user?.userGroup.writePermission.includes(
		PermissionKeys.WEB_SETTING,
	)

	return (
		<div className="space-y-6">
			<div className="space-y-1.5">
				<div className="flex items-start justify-between">
					<Heading
						title={`การตั้งค่า / รายละเอียด สำหรับหน้า: ${name}`}
						description={`จัดการ section และเนื้อหาสำหรับหน้า "${name}"`}
					/>
					<div className="flex">
						<NavigateBackButton />
					</div>
				</div>
			</div>
			<Separator />
			<div className="rounded-lg border bg-card p-6">
				<div className="mb-4 flex items-center justify-between">
					<div className="flex flex-col gap-2">
						<h3 className="text-lg font-semibold">รายการ Section</h3>
						<p className="text-sm text-muted-foreground">
							รายการ section ทั้งหมดที่อยู่ในหน้านี้
						</p>
					</div>
					{hasWritePermission && pageId && (
						<AddSectionToPageModal pageId={pageId} />
					)}
				</div>
				<DynamicPageByIdTable data={data} total={total} isLoading={isLoading} />
			</div>
		</div>
	)
}
